import React from 'react';
import FilterSection from '@/components/ui/FilterSection';

export const LeadExecutionFilter = ({
  searchQuery,
  setSearchQuery,
  statusFilter,
  setStatusFilter,
  customerName,
  setCustomerName,
  dateRange,
  datePreset,
  handleStartDateChange,
  handleEndDateChange,
  handleDatePreset,
  customerList,
  statusList,
  handleExportProjects,
  setPage
}) => {
  return (
    <FilterSection
      search={searchQuery}
      setSearch={setSearchQuery}
      filters={{
        status: statusFilter === 'All statuses' ? 'all' : statusFilter,
        fromDate: dateRange?.from,
        toDate: dateRange?.to,
        date: datePreset,
        customerName: customerName
      }}
      setFilters={(key, val) => {
        if (typeof key === 'object' && key !== null) {
          const obj = key;
          if (obj.status !== undefined) setStatusFilter(obj.status === 'all' ? 'All statuses' : obj.status);
          if (obj.customerName !== undefined) { setCustomerName(obj.customerName); setPage(1); }
          if (obj.date !== undefined && obj.date !== 'all') {
            handleDatePreset(obj.date);
          } else if (obj.date === 'all' && (!obj.fromDate) && (!obj.toDate)) {
            handleDatePreset('all');
          } else {
            if (obj.fromDate !== undefined) handleStartDateChange(obj.fromDate);
            if (obj.toDate !== undefined) handleEndDateChange(obj.toDate);
          }
          return;
        }
        if (key === 'status') setStatusFilter(val === 'all' ? 'All statuses' : val);
        if (key === 'fromDate') handleStartDateChange(val);
        if (key === 'toDate') handleEndDateChange(val);
        if (key === 'date') handleDatePreset(val);
        if (key === 'customerName') { setCustomerName(val); setPage(1); }
      }}
      onExport={handleExportProjects}
      statusPlaceholder="All statuses"
      statusOptions={[
        ...Array.from(new Set(['Not started', 'In Progress', 'Completed', ...(statusList || [])]))
          .filter(Boolean)
          .map(s => ({ label: s, value: s }))
      ]}
      customerOptions={customerList}
    />
  );
};
